(function () {
  let swiperPopularProducts;
  const updateNavPosition = (section) => {
    const nav = section.querySelector(".popular-products-nav");
    if (!nav) return;
    const firstSlide = section.querySelector(".popular-products-item");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(".card");
    if (!imgWrapper) return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    const centerY = offsetTop + imgRect.height / 2;
    nav.style.top = `${centerY}px`;
  };
  const initSlider = (section, mainContainer) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperWrapper = section.querySelector(".popular-products-list");
    const slides = section.querySelectorAll(".popular-products-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;
    swiperEl.classList.add("swiper");
    swiperWrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));
    const prevBtn = section.querySelector(".popular-products-nav-button--prev");
    const nextBtn = section.querySelector(".popular-products-nav-button--next");
    const columns = Number(swiperEl.dataset.columns) || 3;
    const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
    const isLoop = Boolean(swiperEl.dataset.loop);
    // Client request (home #9): "no swiping left/right - use the carousel buttons".
    // Set data-disable-drag on a section to turn off pointer dragging (desktop + tablet).
    // 2026-09-24（客户要求：首页 Best Sellers 桌面端「左右不能滑动」）：
    // data-disable-drag 输出在内层 .popular-products 上，而 schema 的 section class 在外层
    // <section class="shopify-section popular-products-section"> 上，所以只查 section 本身永远查不到，
    // 之前桌面端实际还能拖动（线上实测 allowTouchMove / simulateTouch 都是 true）。两处都查一次。
    const disableDrag =
      section.hasAttribute("data-disable-drag") ||
      Boolean(section.querySelector("[data-disable-drag]"));
    const canDrag = disableDrag
      ? !window.matchMedia("(min-width: 990px)").matches
      : true;
    const autoplaySeconds = Number(mainContainer.dataset.autoplaySeconds) || 0;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const breakpointsConfig = {
      2: {
        576: { slidesPerView: 2.1, spaceBetween: 26 },
        990: { slidesPerView: 2.1, spaceBetween: 34 },
      },
      3: {
        576: { slidesPerView: 2.1, spaceBetween: 26 },
        990: { slidesPerView: 3.15, spaceBetween: 34 },
      },
      4: {
        576: { slidesPerView: 2.1, spaceBetween: 26 },
        990: { slidesPerView: 3.15, spaceBetween: 34 },
        1360: { slidesPerView: 4.15, spaceBetween: 34 },
      },
    };
    const centeredSlidesBreakpointsConfig = {
      576: {
        slidesPerView: 1.5,
        spaceBetween: 26,
        allowTouchMove: true,
        simulateTouch: true,
      },
      // 2026-09-24（首页 Best Sellers）：原来 3.15 张/屏 + centeredSlides 被 loop 影响，
      // 首屏左边只露 4px、右边却切掉一整块（100px）的卡片，看着像坏图。
      // 这里改成正好 3 张、不居中，卡片宽度自动均分容器，两边都不再出现被切一半的卡；
      // 拖动仍然遵守 disable_drag（桌面禁拖动、手机/平板可滑）。
      990: {
        // slidesPerView: "auto"：滑动格宽度由 CSS 决定（见 jc-design-tokens.css 的
        // Best Sellers 段：min(40rem, (100% - 68px) / 3)），Swiper 只读实际宽度来算位移，
        // 这样容器宽度怎么变都正好放下 3 张，不会在第 4 张卡上被切掉一角。
        slidesPerView: "auto",
        spaceBetween: 34,
        centeredSlides: false,
        centeredSlidesBounds: false,
        allowTouchMove: !disableDrag,
        simulateTouch: !disableDrag,
      },
    };
    const sliderOptions = {
      slidesPerView: 1.15,
      spaceBetween: 22,
      speed: 800,
      allowTouchMove: canDrag,
      simulateTouch: canDrag,
      loop: isLoop,
      centeredSlides: isCenteredSlides,
      centeredSlidesBounds: isCenteredSlides,
      autoplay: autoplaySeconds > 0 && !reducedMotion
        ? {
            delay: autoplaySeconds * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      breakpoints: isCenteredSlides
        ? centeredSlidesBreakpointsConfig
        : breakpointsConfig[columns],
      mousewheel: {
        forceToAxis: true,
      },
      a11y: {
        scrollOnFocus: false,
      },
      preventClicks: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    };
    swiperPopularProducts = new Swiper(swiperEl, sliderOptions);
    updateNavPosition(section);
    const nav = section.querySelector(".popular-products-nav");
    if (nav) {
      nav.classList.add("popular-products-nav--visible");
    }
  };
  const destroySlider = (section) => {
    if (!swiperPopularProducts || !section) return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperWrapper = section.querySelector(".popular-products-list");
    const slides = section.querySelectorAll(".popular-products-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;
    swiperPopularProducts.destroy(true, true);
    swiperPopularProducts = null;
    swiperEl.classList.remove("swiper");
    swiperWrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  };
  const marqueeStates = new WeakMap();

  const normaliseOffset = (offset, loopWidth) => {
    if (!loopWidth) return 0;
    return ((offset % loopWidth) + loopWidth) % loopWidth;
  };

  const initMarquee = (section, mainContainer) => {
    const viewport = section.querySelector("[data-marquee-viewport]");
    const track = section.querySelector(".popular-products-list--marquee");
    const originals = track?.querySelectorAll(".popular-products-item:not([data-marquee-clone])");
    const firstClone = track?.querySelector("[data-marquee-clone]");

    if (!viewport || !track || !originals?.length || !firstClone || marqueeStates.has(section)) return;

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // 跑马灯速度（px/秒）。默认 22，可用 data-marquee-speed 覆盖
    // （例如订阅页 Shop our treats 用 44，比首页默认快一倍）。
    const marqueeSpeed = Number(mainContainer.dataset.marqueeSpeed) || 22;
    const state = {
      offset: 0,
      loopWidth: 0,
      lastTime: null,
      paused: reducedMotion,
      dragging: false,
      dragged: false,
      startX: 0,
      startOffset: 0,
      frame: null,
      resumeTimer: null,
      clickResetTimer: null,
    };

    const recalculate = () => {
      state.loopWidth = firstClone.offsetLeft - originals[0].offsetLeft;
      state.offset = normaliseOffset(state.offset, state.loopWidth);
      track.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
    };

    const tick = (time) => {
      if (!state.lastTime) state.lastTime = time;
      const elapsed = Math.min((time - state.lastTime) / 1000, 0.05);
      state.lastTime = time;

      if (!state.paused && !state.dragging && state.loopWidth) {
        state.offset = normaliseOffset(state.offset + elapsed * marqueeSpeed, state.loopWidth);
        track.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
      }

      state.frame = window.requestAnimationFrame(tick);
    };

    const pause = () => {
      state.paused = true;
      if (state.resumeTimer) window.clearTimeout(state.resumeTimer);
    };

    const resume = () => {
      if (!reducedMotion && !state.dragging) state.paused = false;
    };

    const scheduleResume = (delay = 520) => {
      if (state.resumeTimer) window.clearTimeout(state.resumeTimer);
      state.resumeTimer = window.setTimeout(resume, delay);
    };

    viewport.addEventListener("focusin", pause);
    viewport.addEventListener("focusout", () => scheduleResume(320));

    const beginDrag = (clientX, pointerId) => {
      if (state.clickResetTimer) window.clearTimeout(state.clickResetTimer);
      state.dragging = true;
      state.dragged = false;
      state.startX = clientX;
      state.startOffset = state.offset;
      pause();
      mainContainer.classList.add("is-marquee-dragging");
      if (pointerId !== undefined) viewport.setPointerCapture?.(pointerId);
    };

    const moveDrag = (clientX, event) => {
      if (!state.dragging) return;
      const distance = clientX - state.startX;
      if (Math.abs(distance) > 4) {
        state.dragged = true;
        state.offset = normaliseOffset(state.startOffset - distance, state.loopWidth);
        track.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
        event?.preventDefault?.();
      }
    };

    const endDrag = (event) => {
      if (!state.dragging) return;
      state.dragging = false;
      mainContainer.classList.remove("is-marquee-dragging");
      if (event?.pointerId !== undefined && viewport.hasPointerCapture?.(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
      if (state.dragged) {
        if (state.clickResetTimer) window.clearTimeout(state.clickResetTimer);
        state.clickResetTimer = window.setTimeout(() => {
          state.dragged = false;
          state.clickResetTimer = null;
        }, 360);
      }
      scheduleResume(state.dragged ? 760 : 460);
    };

    viewport.addEventListener("pointerdown", (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      beginDrag(event.clientX, event.pointerId);
    });
    viewport.addEventListener("pointermove", (event) => moveDrag(event.clientX, event));
    viewport.addEventListener("pointerup", endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    viewport.addEventListener("touchstart", (event) => {
      if (event.touches.length === 1) beginDrag(event.touches[0].clientX);
    }, { passive: true });
    viewport.addEventListener("touchmove", (event) => {
      if (event.touches.length === 1) moveDrag(event.touches[0].clientX, event);
    }, { passive: false });
    viewport.addEventListener("touchend", endDrag);
    viewport.addEventListener("touchcancel", endDrag);
    viewport.addEventListener("click", (event) => {
      if (!state.dragged) return;
      event.preventDefault();
      event.stopPropagation();
      state.dragged = false;
      if (state.clickResetTimer) window.clearTimeout(state.clickResetTimer);
      state.clickResetTimer = null;
    }, true);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) pause();
      else resume();
    });

    const observer = new ResizeObserver(recalculate);
    observer.observe(viewport);
    recalculate();
    state.frame = window.requestAnimationFrame(tick);
    marqueeStates.set(section, state);
  };

  const initPopularProducts = (section) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;
    const mainContainer = section.querySelector(".popular-products");
    if (!mainContainer) return;
    if (mainContainer.dataset.marquee === "true") {
      initMarquee(section, mainContainer);
      return;
    }
    const desktopLayout = mainContainer.dataset.layout;
    const mobileLayout = mainContainer.dataset.layoutMobile;
    let currentLayout = null;
    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let newLayout;
      if (entry.contentRect.width < 576) {
        newLayout = mobileLayout;
      } else {
        newLayout = desktopLayout;
      }
      if (newLayout !== currentLayout) {
        if (swiperPopularProducts) {
          destroySlider(section);
        }
        if (newLayout === "slider") {
          initSlider(section, mainContainer);
        }
        currentLayout = newLayout;
      }
      if (currentLayout === "slider") {
        updateNavPosition(section);
      }
    });
    sectionResizeObserver.observe(section);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initPopularProducts(document.currentScript.parentElement);
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initPopularProducts(event.target);
    initHeadingAnimation(event.target);
  });
})();
